// @flow
import { get } from "lodash";
import type { OperationComponent } from "@apollo/client";
import type { RaceCardProps } from "@fdr/types/ProgramPage";

const QUERY_VARIABLES = {
  trackAbbr: null,
  wagerProfile: "FDR-Generic",
  raceNumber: 0
};

export default {
  options: (props: RaceCardProps) => {
    const variables = {
      ...QUERY_VARIABLES,
      trackAbbr: get(props, "race.track.trackCode", "").toUpperCase(),
      wagerProfile: get(props, "wagerProfile", ""),
      raceNumber: +get(props, "race.raceNumber", ""),
      numOfRaces: +get(props, "wagerType.legCount", 1)
    };

    return {
      fetchPolicy: "cache-and-network",
      ssr: false,
      variables
    };
  },
  props: (result: OperationComponent<Response>) => ({
    results: get(result, "data.track.races[0].results"),
    isLoading: result.data.loading,
    subscribeToMore:
      get(result, "ownProps.hasWebSockets", false) && !result.data.loading
        ? result.data.subscribeToMore
        : null,
    refetch: result.data.refetch
  })
};
